import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
// import HomeAbout from '../components/About/HomeAbout.jsx';

// import AboutFive from '../container/About/AboutFive';
// import TestimonialContainer from '../container/Testimonial/TestimonialContainer';
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";
// import {Link} from "react-router-dom";

// import EmptyOne from '../container/Empty/EmptyOne';

const Visa = () => {
  return (
    <React.Fragment>
      <SEO title="Visa | ICSI 2023" />
      <Header />
      <Breadcrumb
        image="images/banner/banner.jpg"
        title="Visa"
        content="For Participants"
        contentTwo="Visa"
        // linkage="/"

      />

      {/* <HomeAbout /> */}
      <EmptyTwo>
        <div className="entry-content">
          <div className="visa">
            <h3>
              Visa Information
            </h3>
            {/* <div align="justify">
            <p align="justify">Participants who need a visa to enter Japan should apply to the Embassy or Consulate General of Japan in their resident countries with all required documents. See detail&nbsp;visa information at&nbsp;the&nbsp;<a href="http://www.mofa.go.jp/j_info/visit/visa/" >Ministry of Foreign Affairs</a>&nbsp;of Japan and&nbsp;<a href="http://www.mofa.go.jp/j_info/visit/visa/short/novisa.html#section2" >countries for visa&nbsp;exemptions</a>.</p>





            </div> */}

            <div style={{ marginBottom: '40px' }}>
              <h4 style={{ color: '#030f27', marginTop: '30px', marginBottom: '20px', fontSize: '24px', fontWeight: '700' }}>
                🛂 China Visa-Free & Transit Policies (Updated for 2026)
              </h4>

              <div style={{ marginBottom: '30px', padding: '20px', backgroundColor: '#f8faff', borderRadius: '5px', borderLeft: '4px solid #1292ee' }}>
                <h5 style={{ color: '#030f27', marginTop: '0', marginBottom: '15px', fontSize: '20px', fontWeight: '600' }}>
                  30-Day Visa-Free Entry
                </h5>
                <p align="justify" style={{ marginBottom: '15px' }}>
                  China currently implements a unilateral visa-free entry policy for nationals of certain countries holding valid ordinary passports. Eligible visitors can enter mainland China and stay visa-free for up to 30 days for purposes such as business, tourism, visiting family/friends, exchanges, or transit, without applying for a visa in advance. This policy has been extended through December 31, 2026.
                </p>
                <p align="justify" style={{ marginBottom: '0' }}>
                  Official details and the full list of eligible countries can be found here:{" "}
                  <a href="https://www.visaforchina.cn/SGP3_EN/qianzhengyewu/jichuzhishi/changjianwenti/220323827614355469.html" target="_blank" rel="noopener noreferrer" style={{ color: '#1292ee', textDecoration: 'underline' }}>
                    Visa-Free Entry Policies for Foreign Nationals (FAQ) — visaforchina.cn (English)
                  </a>
                </p>
              </div>

              <div style={{ marginBottom: '30px', padding: '20px', backgroundColor: '#f8faff', borderRadius: '5px', borderLeft: '4px solid #1292ee' }}>
                <h5 style={{ color: '#030f27', marginTop: '0', marginBottom: '15px', fontSize: '20px', fontWeight: '600' }}>
                  240-Hour Visa-Free Transit
                </h5>
                <p align="justify" style={{ marginBottom: '15px' }}>
                  For travellers from many countries who are not eligible for the 30-day visa-free entry, China also offers a 240-hour (10-day) visa-free transit option if:
                </p>
                <ul style={{ marginLeft: '20px', marginBottom: '15px', paddingLeft: '20px' }}>
                  <li style={{ marginBottom: '8px' }}>they hold valid travel documents and a confirmed onward ticket to a third country/region (e.g., departing China to a different destination), and</li>
                  <li style={{ marginBottom: '8px' }}>they enter via one of the designated entry points.</li>
                </ul>
                <p align="justify" style={{ marginBottom: '15px' }}>
                  Under this policy, eligible travellers may stay in China up to 240 hours (10 days) without a visa, engaging in tourism, business, or visits within the permitted zones.
                </p>
                <p align="justify" style={{ marginBottom: '0' }}>
                  Official reference:{" "}
                  <a href="https://bio.visaforchina.cn/SYD3_EN/tongzhigonggao/329041139338448896.html" target="_blank" rel="noopener noreferrer" style={{ color: '#1292ee', textDecoration: 'underline' }}>
                    China&apos;s 240-Hour Visa-Free Transit Policy — National Immigration Administration / Embassy pages
                  </a>
                </p>
              </div>

              <div style={{ marginTop: '25px', padding: '15px', backgroundColor: '#fff3cd', borderRadius: '5px', borderLeft: '4px solid #ffc107' }}>
                <p align="justify" style={{ marginBottom: '0', fontStyle: 'italic', color: '#856404' }}>
                  <strong>Note:</strong> Requirements and eligible nationalities for visa-free and transit policies may change; please refer to the official Chinese visa authority sites above for the most current updates.
                </p>
              </div>
            </div>

            <hr style={{ marginTop: '40px', marginBottom: '40px', borderTop: '2px solid #e7e7e7' }} />

            <h4 style={{ color: '#030f27', marginTop: '30px', marginBottom: '20px', fontSize: '24px', fontWeight: '700' }}>
              Ordinary Visa Categories
            </h4>
            <p align="justify">
              The ordinary visas consist of eight sub-categories, which are
              marked with Chinese phonetic letters (D, Z, X, F, L, G, C, J-1 and
              J-2 respectively).
            </p>
            <p align="justify">
              <b>Visa D</b>: issued to aliens who are to reside permanently in
              China. A permanent residence confirmation form shall be required
              for the application of Visa D. The applicant shall apply to obtain
              this form himself or through his designated relatives in China
              from the exit-and-entry department of the public security bureau
              in the city or county where he applies to reside.
            </p>
            <p align="justify">
              <b>Visa Z</b>: Issued to aliens who are to take up posts or
              employment in China, and to their accompanying family members. To
              apply for a Visa Z, an Employment License of the People’s Republic
              of China for Foreigners (which could be obtained by the employer
              in China from the provincial or municipal labor authorities) and a
              visa notification letter/telegram issued by an authorized
              organization or company are required.
            </p>
            <p align="justify">
              <b>Visa X</b>: Issued to aliens who come to China for study,
              advanced studies or job-training for a period of six months or
              more. To apply for a Visa X, certificates from the receiving unit
              and the competent authority concerned are required, i.e.,
              Application Form for Overseas Students to China (JW201 Form or
              JW202 Form), Admission Notice and Physical Examination Record for
              Foreigners.
            </p>
            <p align="justify">
              <b>Visa F</b>: Issued to an applicant who is invited to China on a
              visit, on a study or lecture, business tour, for
              scientific-technological and cultural exchanges, for short-term
              refresher course or for job-training, for a period of no more than
              six months. To apply for a Visa F, the invitation letter from the
              inviting unit or the visa notification letter/telegram from the
              authorized unit is required.
            </p>
            <p align="justify">
              <b>Visa L</b>: Issued to aliens who come to China for sightseeing,
              visiting relatives or other private purposes. For a tourist
              applicant, in principle he shall evidence his financial capability
              of covering the travelling expenses in China, and when necessary,
              provide the air, train or ship tickets to the heading
              country/region after leaving China. For the applicants who come to
              China to visit relatives, some are required to provide invitation
              letters from their relatives in China.
            </p>
            <p align="justify">
              <b>Visa G</b>: Issued to aliens who transit through China. The
              applicants are required to show valid visas and on-going tickets
              to the heading countries/regions.
            </p>
            <p align="justify">
              <b>Visa C</b>: Issued to train attendants, air crewmembers and
              seamen operating international services, and to their accompanying
              family members. To apply for a visa C, relevant documents are
              required to be provided in accordance with bilateral agreements or
              regulations of the Chinese side.
            </p>
            <p align="justify">
              <b>Visa J-1</b>: Issued to foreign resident correspondents in
              China.
            </p>
            <p align="justify">
              <b>Visa J-2</b>: Issued to foreign correspondents who make short
              trip to China on reporting tasks.
            </p>
            <p align="justify">
              The applicants for J-1 and J-2 visas are required to provide a
              certificate issued by the competent Chinese authorities.
            </p>
            <p align="justify">
              In addition to providing the above-mentioned documents, an
              applicant is also required to answer relevant questions and go
              through the following formalities (with the exception of those
              stipulated otherwise by agreements):Providing valid passport or a
              travel document in lieu of the passport Filling out a visa
              application form, and providing a recent 2-inch, bareheaded and
              full-faced passport photo.
            </p>
            <p align="justify">
              The overseas Chinese visa authorities are Chinese embassies,
              consulates, visa offices, the consular department of the Office of
              the Commissioner of the Ministry of Foreign Affairs in HKSAR, and
              other agencies abroad authorized by the Ministry of Foreign
              Affairs of China. If a foreigner intends to enter into, exit from
              or transit through the Chinese territory, he shall apply to the
              above-mentioned Chinese visa authorities for a Chinese visa.
            </p>
            <p align="justify">
              For further information, please consult the nearest Chinese visa
              authorities.
            </p>
            <p align="justify">
              The above message is quoted from{" "}
              <a href="http://www.fmprc.gov.cn/eng/default.htm">
                Ministry of Foreign Affairs , the People’s Republic of China
              </a>
              .
            </p>
          </div>
        </div>
      </EmptyTwo>
      {/* <AboutFive />
            <TestimonialContainer classOption="bg-primary-blue" />
            <CallToActionTwo /> */}
      <Footer />
      <ScrollToTop />
    </React.Fragment>
  );
};

export default Visa;
